import { defineView } from "~/setup/view-definitions";

const definition = defineView({
    name: "AuthorDetails",
    component: () => import("~/views/author-details/author-details-view")
});

export default definition;
